import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DataService } from './data.service';
import { map, tap } from 'rxjs/operators';
import { Timereport } from '../timereport/interfaces';
import { MaterialItem } from '../balances/interfaces/material-item';
import { Order } from '../order/interfaces/order';
import { OrderEntryComponent } from '../order/components/order-entry.component';
import { Budget } from '../budget/interfaces';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AuthService } from './auth.service';

@Injectable()
export class BudgetService {

  private cDR: AngularFirestoreDocument<any>;

  constructor(private dataService: DataService,
    private afs: AngularFirestore,
    private auth: AuthService,
    ) {
      this.cDR = this.auth.customerDocumentReference;
  }

  public createSummaryDoc(summaryData, budgetId) {
    return this.cDR.collection('SummaryCollection').doc(budgetId).set(summaryData);
  }

  public getSummaryBalanceByBudget(budgetId: string): Observable<SummaryBalanceData> {

    const timeReports$ = this.dataService.getTimereportByBudget(budgetId)
      .pipe(
        map((trList) => trList.map((tr) => {
          const data = tr.payload.doc.data() as Timereport;
          const id = tr.payload.doc.id;
          if (!('totalValue' in data)) {
            try {
              data.totalValue = data.hours * data.actualCost;
            } catch (err) {
              data.totalValue = 0;
            }
          }
          return { id: id, ...data };
        }))
      );

    const materialItems$ = this.dataService.getOrdersByBudget(budgetId)
      .pipe(
        map((orders: Order[]) => {
          return orders
          .filter(o => o.deleted !== true)
          .map(o => o.items)
          .reduce((i1, i2) => i1.concat(i2), [])
          .filter((i) => (i.budget && i.budget.id === budgetId));
        })
      );

    // this.materialTotalCost = this.materialList$.map((list) =>  list.map(i => i.total).reduce((a, b) => a + b, 0));

    return Observable.combineLatest([
      this.dataService.getSimpleBudget(budgetId),
      timeReports$,
      materialItems$
    ]).pipe(
      map(([b, a, o]: [Budget, any, any]) => {

        const totAct = a.filter((t: Timereport) => !Number.isNaN(t.totalValue))
          .map((t: Timereport) => t.totalValue)
          .reduce((t1: number, t2: number) => t1 + t2, 0);

        const totMat =  o.map(i => OrderEntryComponent.calculateEntryValue(i))
        .reduce((t1, t2) => t1 + t2, 0);

        const costSummary = (b).costSummary;

        const summary: any = {
          budgetId,
          budgetNr: b.budgetNr,
          budget: {
            act: costSummary ? costSummary.hoursValue : 0,
            mat: costSummary ? costSummary.goodsValue : 0,
          },
          final: {
            act: totAct,
            mat: totMat,
          }
        };

        if (b.project) {
          const revenue = b.project.finalInvoiced ? b.project.finalInvoiced : 0;
          const finalOffer = b.project.finalOfferOrder ? b.project.finalOfferOrder : 0;
          summary.revenue = revenue;
          summary.finalOffer = finalOffer;
          summary.profit = {
            budget: finalOffer - summary.budget.act - summary.budget.mat,
            final: revenue - summary.final.act - summary.final.mat
          };
        } else {
          summary.revenue = 0;
          summary.profit = {
            budget: 0,
            final: 0
          };
        }

        console.log("Summary", summary)
        return summary;
      })
    );
  }

}

export interface SummaryBalanceData {
  budgetId: string;
  budgetNr: string;
  budget: {
    act: number,
    mat: number,
  };
  final: {
    act: number,
    mat: number
  };
}



// WEBPACK FOOTER //
// ./src/app/services/budget.service.ts